Core.AssetsRouter = Core.SubRouter.extend({
    routes: {
        '': 'assets',
        'fuelsummary': 'viewFuelSummary',
        'types': 'assetTypes',
        'favourites': 'favouriteAssets',
        'attachable': 'attachableAssets',
        'new': 'createAsset',
        'type/:id': 'viewAssetType',
        'type/:id/edit': 'editAssetType',
        'new-type': 'createAssetType',
        ':id': 'viewAsset',
        ':id/edit': 'editAsset',
        'report/:id': 'viewAssetReport',
    },

    assets: function () {
      debug.log('assets');
      app.setMainView(new AssetListView({scrolling: true}), 'directory');
    },

    assetTypes: function () {
        debug.log('asset types');
        app.setMainView(new AssetTypeListView({scrolling: true}), 'directory');
    },

    favouriteAssets: function() {
        debug.log('favourites');
        var collection = new Core.Assets([], { filterParams: { favourites: true } });
        collection.fetchAndCache();
        app.setMainView(new AssetListView({scrolling: true, collection: collection, isFavouritesView: true}), 'directory');
    },

    attachableAssets: function() {
        debug.log('attachable assets');
        app.setMainView(new AttachableAssetListView({scrolling: true}), 'directory');
    },

    createAsset: function () {
      debug.log('create asset');
      app.setMainView(new AssetDetailsView({editing: true}), 'directory');
    },

    viewAssetType: function(id) {
        debug.log('View asset type:', id);
        app.setMainView(new AssetTypeDetailsView({id: id})), 'directory';
    },

    editAssetType: function (id) {
        debug.log('Edit asset type:', id);
        app.setMainView(new AssetTypeDetailsView({id: id, editing: true})), 'directory';
    },
    
    createAssetType: function () {
        debug.log('create asset type');
        app.setMainView(new AssetTypeDetailsView({editing: true}), 'directory');
    },

    viewAsset: function (id) {
        debug.log('view asset', id);
        app.setMainView(new AssetDetailsView({id: id}), 'directory');
    },

    editAsset: function (id) {
        debug.log('edit asset', id);
        app.setMainView(new AssetDetailsView({id: id, editing: true}), 'directory');
    },

    viewAssetReport: function(id) {
        debug.log('view report:', id);
        app.setMainView(new TrackUnitAssetReportView({id: id}), 'directory');
    },

    viewFuelSummary: function() {
        debug.log('fuel summary');
        app.setMainView(new AssetFuelSummaryView(), 'directory');
    }
});
